import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../../ui/dialog";
import { useState } from "react";
import Button from "../../form/button";
import ErrorMessage from "../../form/errorMessage";
import { Input } from "../../ui/input";
import pb from "../../../lib/pocketbase";
import { useToast } from "../../ui/use-toast";

export default function ChangeEmail() {
    const { toast } = useToast();
    const [newEmail, setNewEmail] = useState("");
    const [open, setOpen] = useState(false);
    const [error, setError] = useState("");

    function change() {
        pb.collection("users")
            .requestEmailChange(newEmail)
            .then(() => {
                setOpen(false);
                toast({
                    title: "📩 Mail send!",
                    description: "Mail to verify email change has been send!"
                });
            })
            .catch((err: Error) => {
                setError(err.message);
            });
    }

    return (
        <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
                <Button className="w-full md:w-fit">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="h-5 w-5">
                        <path strokeLinecap="round" d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25" />
                    </svg>
                    Change email
                </Button>
            </DialogTrigger>
            <DialogContent className="mt-8 md:mt-0">
                <DialogHeader>
                    <DialogTitle>Enter new email</DialogTitle>
                    <DialogDescription>Enter the new email that you want to use. A email will be send to then verify the change.</DialogDescription>
                </DialogHeader>
                <ErrorMessage error={error} close={() => setError("")} />
                <Input value={newEmail} onChange={(e) => setNewEmail(e.target.value)} onKeyDown={(e) => e.key === "Enter" && change()} placeholder="john@example.com" />
                <DialogFooter className="gap-2">
                    <Button onClick={() => setOpen(false)}>Cancel</Button>
                    <Button onClick={() => change()} variant="dark">
                        Request change
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
